import { Component, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule,JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { MtrwlService, templateUrlConfigMtr } from '../_service_mtr';
import { Mtrwl } from '../_entity_mtr';


@Component({
  selector: 'app-mtrwl-edit',
  templateUrl: './mtrwl-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, AdvComModule,MaterialModule],
})

export class MtrwlEditComponent extends JkDialogEditComponent<MtrwlService,Mtrwl>{
  override srv!: MtrwlService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<MtrwlEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject,dialogRef,data);
  }


}